import { get, writable } from "svelte/store";
import { getDistance } from "geolib";
import journey, { journeySubscribeThrottled } from "./journey.js";
import { article as articleAt } from "../api/api.js";
import windows from "./windows.js";

const MINIMUM_DISTANCE_INTERVAL_METERS = 1000;

function createArticleStore() {
    const store = writable({
        all: [],
        indexForCurrent: undefined,
        isLoading: false
    });

    const { subscribe, update } = store;

    let lastUpdatedAt;

    function updateArticle(location) {
        lastUpdatedAt = location;

        update((state) => ({
            ...state,
            isLoading: true
        }));

        articleAt(location)
            .then(({ article }) => {
                if (article) {
                    update((state) => {
                        const isSameArticle =
                            state.all.length > 0 &&
                            !!state.all.find(
                                ({ title }) => title === article.title
                            );

                        if (isSameArticle) {
                            return state;
                        }

                        return {
                            ...state,
                            all: [...state.all, article],
                            indexForCurrent: state.isPaused
                                ? Number.isFinite(state.indexForCurrent)
                                    ? state.indexForCurrent
                                    : state.all.length
                                : state.all.length,
                            isLoading: false
                        };
                    });
                } else {
                    update((state) => ({
                        ...state,
                        isLoading: false
                    }));
                }
            })
            .catch((error) => {
                console.warn("failed to fetch article", error.message);

                update((state) => ({
                    ...state,
                    isLoading: false
                }));
            });
    }

    journeySubscribeThrottled(11000, ({ location }) => {
        const shouldUpdate =
            location &&
            (lastUpdatedAt === undefined ||
                getDistance(lastUpdatedAt, location) >
                    MINIMUM_DISTANCE_INTERVAL_METERS);

        if (!shouldUpdate) {
            return;
        }

        updateArticle(location);
    });

    windows.onOpen("article", function didOpenWindow() {
        const shouldUpdate = get(store).all.length === 0;

        if (shouldUpdate) {
            updateArticle(get(journey).location);
        }
    });

    return {
        subscribe,

        previous() {
            update((state) => ({
                ...state,
                indexForCurrent: Math.max(state.indexForCurrent - 1, 0)
            }));
        },

        next() {
            update((state) => ({
                ...state,
                indexForCurrent: Math.min(
                    state.indexForCurrent + 1,
                    state.all.length - 1
                )
            }));
        },

        pause() {
            update((state) => ({
                ...state,
                isPaused: true
            }));
        },

        resume() {
            update((state) => ({
                ...state,
                isPaused: false
            }));
        }
    };
}

const article = createArticleStore();

export default article;
